import { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import PreviewArticleComp from "../../Components/Articles/PreviewArticle";
import LegacyPreviewArticleComp from "../../Components/Legacy/LegacyPreviewArticleComp";
import { useArticle } from "../../hooks/apis/useArticle";
import ScrollToTop from "../../Components/ScrollToTop";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { ArticleLoader } from "../../Components/Loaders/Article";
import { KBContext } from "../../Context/index";
import { isFeatureEnabled, isNewUIEnabled } from "../../utils";

export default function PreviewArticle() {
  const { categorySlug: pathCategorySlug, articleSlug } = useParams();
  const navigate = useNavigateWithSearch({ keepHash: true });
  const { data: selectedArticle, error, isLoading } = useArticle({ articleSlug });
  const { availableFeatures } = useContext(KBContext);
  const isNewUI = isNewUIEnabled(availableFeatures);

  useEffect(() => {
    if( !error ){
      return;
    }
    // handle if article api fails
    if( error?.response?.status === 404 ){
      handleGainSightEventForPageNotFound(window.location.href);
    }
    navigate("/not-found");
  }, [ error, navigate ]);

  useEffect(() => {
    if( !selectedArticle?.fullPath ){
      return;
    }
    const categorySlug = selectedArticle.fullPath.split('/').at(-2);
    if( categorySlug && pathCategorySlug !== categorySlug ){
      navigate(`/${categorySlug}/${articleSlug}`, { replace: true });
    }
  }, [ pathCategorySlug, articleSlug, selectedArticle, navigate ]);

  useEffect(() => {
    if (isNewUI && selectedArticle) {
      window.scrollTo(0, 0);
      const t = setTimeout(() => window.scrollTo(0, 0), 100);
      return () => clearTimeout(t);
    }
  }, [selectedArticle?.id, isNewUI]);

  if (isLoading) {
    return (
      <>
        <ScrollToTop />
        <ArticleLoader />
      </>
    );
  }

  if (!selectedArticle) {
    return null;
  }

  const ArticleComp = isNewUI ? PreviewArticleComp : LegacyPreviewArticleComp;

  return (
    <>
      <ScrollToTop />
      <ArticleComp
        selectedArticle={selectedArticle}
      />
    </>
  );
}
